<div class="card-account" (click)="onClickList(card)">
  <ng-container *ngIf="!card?.type">
    <div class="card-icon">
      <div *ngIf="card.brand== 'Visa'" style="height: 25px;"><img src="/assets/logo/visa.svg" alt="VISA Card" style="width:25px; height:25px;"/></div>
      <div *ngIf="card.brand=='MasterCard'" style="height: 25px;"><img src="/assets/logo/mastercard.svg" alt="MasterCard" style="width:25px; height:25px;"/></div>
      <div *ngIf="card.brand=='American Express'" style="height: 25px;"><img src="/assets/logo/american-express.svg" alt="American Express" style="width:25px; height:25px;"/></div>
    </div>
    <div>{{card.brand}} ending in {{card.last4}}</div>
    <div style="padding-left: 20px">{{card.exp_month}}/{{card.exp_year}}</div>
    <div class="default-label" *ngIf="defaultPaymentId === card.id">Default</div>
  </ng-container>
  <ng-container *ngIf="card?.type">
    <div>{{card.msg}}</div>
  </ng-container>
</div>